import React from 'react';
import { withFormsy } from 'formsy-react';
import _ from 'lodash';
import { InputLabel, Select, OutlinedInput, MenuItem, FormHelperText } from '@mui/material';

export class SelectInput extends React.Component {
  constructor(props) {
    super(props);

    this.changeValue = this.changeValue.bind(this);
  }

  changeValue(event) {
    const { onChange, setValue } = this.props;
    if (onChange) onChange(event);
    setValue(event.target.value);
  }

  render() {
    const { name, label, options, disabled, hint, value, errorMessage, isPristine } = this.props;
    const isError = !isPristine && errorMessage != null;

    return (
      <div className="input-container">
        <InputLabel htmlFor={name} error={isError}>{label}</InputLabel>
        <Select
          error={isError}
          id={name}
          name={name}
          onChange={this.changeValue}
          value={value || ''}
          input={<OutlinedInput name={name} style={{marginTop: '8px', marginBottom: '4px'}} />}
          disabled={disabled}
          fullWidth
        >
          <MenuItem value="" disabled></MenuItem>
          {options.map((option, i) => (
            _.isString(option) ?
              <MenuItem key={i} value={option}>{option}</MenuItem>
            :
              <MenuItem key={i} value={option.value}>{option.label}</MenuItem>
          ))}
        </Select>
        {!isPristine && errorMessage &&
          <FormHelperText error={isError} className="input-error">{errorMessage}</FormHelperText>
        }
        {hint &&
          <FormHelperText>{hint}</FormHelperText>
        }
      </div>
    );
  }
}

export default withFormsy(SelectInput);
